<template>
    <footer class="footer">
        <div class="content has-text-centered">
            Copyright 2012 - {{year}} OBOSITII.org
        </div>
    </footer>
</template>

<script>
  import moment from 'moment';

  export default {
    name: "footer-bar",
    data() {
      return {
        year: parseInt(moment().format('Y'))
      };
    }
  }
</script>

<style scoped>
    .footer {
        padding: 1.2rem;
        position: fixed;
        bottom: 0;
        width: 100%;
        font-size: 0.75rem;
    }
</style>